import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Card, CardBody, Button, Row, Input } from 'reactstrap';
import avatarDefault from '../../../../shared/img/avatar-default.jpg';

const formatDescription = (value = '') => value.replace('↵', '\n');

const CaseActivitiesCard = ({
  isAuditor,
  rut,
  status,
  activities,
  onClickModalAssignActivity,
}) => (
  <Card className="cardo_botton" style={{ height: 'auto' }}>
    <CardBody style={{ padding: '0px 10px' }}>
      <div className="profile_casos profile_casos_detail">
        {!isAuditor && (
          <div className="col-md-12" style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', padding: '10px 0px' }}>
            {!rut && (status === 'opened' || status === 're-opened') && (
              <Button className="asignar button_details" style={{ margin: '0px' }} onClick={onClickModalAssignActivity}>
                Anadir actividad
              </Button>
            )}
          </div>
        )}
        {activities.length > 0 && (
          <div className="col-md-12" style={{ height: '300px', overflowY: 'scroll', marginBottom: '5%' }}>
            {activities.map((activity) => (
              <div key={activity._id} className="cards_reply" style={{ marginBottom: '3%' }}>
                <Row className="row_flexible">
                  <div className="compacted col-md-5">
                    <div className="profile_avatar_details">
                      <img src={activity?.executive?.avatar ? avatarDefault : ''} alt="avatar" />
                    </div>
                    <div className="profile_info col-md-8" style={{ textAlign: 'center' }}>
                      <h5>{activity.executive ? `${activity.executive.firstName} ${activity.executive.lastName}` : 'Sin nombre'}</h5>
                    </div>
                  </div>
                  <div className="compacted col-md-7">
                    <h6>{moment(activity.date).format('DD/MM/YYYY HH:mm')}</h6>
                  </div>
                </Row>
                <Row>
                  <div className="compacted col-md-12" style={{ padding: '0px 40px' }}>
                    <Input
                      type="textarea"
                      maxLength="300"
                      minLength="30"
                      style={{ height: '100px' }}
                      name="clientActivity"
                      id={`clientActivity-${activity._id}`}
                      className="newArea"
                      disabled
                      value={formatDescription(activity.description)}
                    />
                  </div>
                </Row>
              </div>
            ))}
          </div>
        )}
      </div>
    </CardBody>
  </Card>
);

CaseActivitiesCard.propTypes = {
  isAuditor: PropTypes.bool.isRequired,
  rut: PropTypes.string,
  status: PropTypes.string,
  activities: PropTypes.arrayOf(PropTypes.shape({
    _id: PropTypes.string,
    date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    description: PropTypes.string,
    executive: PropTypes.shape({
      avatar: PropTypes.string,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
    }),
  })),
  onClickModalAssignActivity: PropTypes.func.isRequired,
};

CaseActivitiesCard.defaultProps = {
  rut: '',
  status: '',
  activities: [],
};

export default CaseActivitiesCard;
